export default {
  currentFundingReasonFormName: '',
  fundingAmount: null
}
